<template>

      <main class="column">
      <div class="level">
        <div class="level-left">
          <div class="level-item">
            <div class="subtitle">Dashboard</div>
          </div>
        </div>
        <div class="level-right">
          <div class="level-item">
            <div class="subtitle">
            {{moment(date).format('DD MMMM YYYY')}}
            </div>
          </div>
        </div>
      </div>
      
      <div class="columns is-multiline">
        <div class="column" >
          <div class="box" id="card1">
            <!-- <i class="fa  mdi-chart-line mdi-24px float-right"></i> -->
            <div class="heading"><font color="white">Total Queries</font></div>
            <div class="title"><font color="white">{{queries.length}}</font></div>
          
          </div>
        </div>
        <div class="column" >
          <div class="box" id="card1">
            <div class="heading"><font color="white">Total Hotels</font></div>
            <div class="title" v-if="hotels"><font color="white">{{hotels.length}}</font></div>
          
          </div>
        </div>
        <div class="column" >
          <div class="box" id="card1">
            <div class="heading"><font color="white">Total Agents</font></div>
            <div class="title" v-if="users"><font color="white">{{users.length}}</font></div>
          
          </div>
        </div>
        
      </div>
      
 <div class="subtitle">Recent Queries</div>
 <div class="box">
         <b-table
            :data="queries"
            :current-page.sync="currentPage"
            :per-page="perPage"
            
            :mobile-cards="hasMobileCards"
            :default-sort-direction="defaultSortDirection"
             default-sort="qury.queryNo"
       >
            <template slot-scope="props">
               
               
                <b-table-column field="queryNo" label="Query No." sortable >
                   <strong> {{ props.row.queryNo }} </strong>
                </b-table-column>
                <b-table-column field="queryDate" label="Query Date" sortable  >
                      {{moment(props.row.queryDate).format('Do MMM YYYY')}}
                </b-table-column>
                    <b-table-column field="createdBy" label="Agent" sortable >
                    {{ props.row.createdBy }}
                </b-table-column>
                    <b-table-column field="travelDate" label="Travel Date" sortable >
                   {{moment(props.row.travelDate).format('Do MMM YYYY')}}
                </b-table-column>
                    <b-table-column field="nights" label="Nights" sortable >
                    {{ props.row.nights }}
                </b-table-column>
          <b-table-column field="status" label="Status" sortable >
          <span class="tag is-dark" v-if="props.row.status == 'query'">Query</span>
          <span class="tag is-success" v-if="props.row.status == 'confirmed'">Confirmed</span>
          <span class="tag is-warning" v-if="props.row.status == 'waitingForConfirmation'">Waiting For Confirmation</span>
          <span class="tag is-danger" v-if="props.row.status == 'cancelled'">Cancelled</span>
          <span class="tag is-danger" v-if="props.row.status == 'waitingForCancellation'">Waiting For Cancellation</span>
          <span class="tag is-danger" v-if="props.row.status == 'rejected'">Rejected</span>
                </b-table-column>
               <!--  <b-table-column field="action" label="Actions">
          <i class="fa fa-eye icon" @click="openModal(props.row)" title="Edit qury" ></i>
          <i class="fa fa-print icon" @click="openModal(qury)" title="Edit qury" ></i>
                </b-table-column> -->
            </template>

            <template slot="empty">
                <section class="section">
                    <div class="content has-text-grey has-text-centered">
                        <p>
                            <b-icon
                                icon="emoticon-sad"
                                size="is-large">
                            </b-icon>
                        </p>
                        <p>Nothing here.</p>
                    </div>
                </section>
            </template>
        </b-table>
    </div>
    </main>
    
      
</template>

<script>
import moment from 'moment';
import CityService from '../hotel/service';
import QueryService from '../quries/service';
import UsersService from '../users/service';
  export default {
    name: 'analytics',
    created() {
      this. fetcQueries();
       this.fetchCities();
       this.fetchUsers();
     
    },
    data(){
return {
    
hotels: [],
users: [],
queries : [],
date : {},
status,
isBordered: true,
       isStriped: true,
       isNarrowed: false,
       isHoverable: true,
       isFocusable: false,
       hasMobileCards: true,
       isPaginated: true,
       isPaginationSimple: false,
       defaultSortDirection: 'asc',
       currentPage: 1,
       perPage: 10
//isNarrowed: true,
// hasMobileCards: true
    };
    
    },
    
     methods: {
   
    fetcQueries() {
      QueryService.all().then(query => {
        this.queries = query;
        this.isLoading = false;
      });
    },
    fetchCities() {
      CityService.all().then(hotels => {
        this.hotels = hotels;
        this.isLoading = false;
      });
    },

     fetchUsers() {
      this.isUsersLoading = true;
      this.users = null;
      UsersService.all().then(users => {
        this.users = users;
        this.isUsersLoading = false;

      });
    }

   
  }
  }

</script>
<style scoped>
#card1{
  background: linear-gradient(233deg, #eb014f, #5e005e, #eb014f);
background-size: 400% 400%;

-webkit-animation: AnimationName 0s ease infinite;
-moz-animation: AnimationName 0s ease infinite;
animation: AnimationName 0s ease infinite;

@-webkit-keyframes AnimationName {
    0%{background-position:48% 0%}
    50%{background-position:53% 100%}
    100%{background-position:48% 0%}
}
@-moz-keyframes AnimationName {
    0%{background-position:48% 0%}
    50%{background-position:53% 100%}
    100%{background-position:48% 0%}
}
@keyframes AnimationName { 
    0%{background-position:48% 0%}
    50%{background-position:53% 100%}
    100%{background-position:48% 0%}
}
}
</style>


// WEBPACK FOOTER //
// src/pages/dashboard/Analytics.vue